import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export const ErrorDialog = ({ show, handleClose, title, message }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message || 'Error al enviar'}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button  
          style={{marginRight: '10px', backgroundColor: '#933A16', borderColor: '#933A16'}}
          onClick={handleClose}>
          Volver
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
